import type * as THREE from "three";

/**
 * Vertices closer than this (metres) are the same vertex. Every edge that survives has
 * lengthSq ≥ 1e-10, the DEGENERATE_EPSILON the offset helpers refuse to work below.
 */
const POINT_EPSILON = 1e-5;
const POINT_EPSILON_SQ = POINT_EPSILON * POINT_EPSILON;

/**
 * Drops every vertex that coincides with the one kept before it; for a ring also the trailing
 * vertices that coincide with the first one (a GeoJSON-style closed ring becomes open). Returns
 * the surviving originals, not clones.
 */
function dropDegenerateVertices({ points, isLoop }: { points: ReadonlyArray<THREE.Vector3>; isLoop: boolean }): Array<THREE.Vector3> {
	const kept: Array<THREE.Vector3> = [];

	for (const point of points) {
		const previous = kept.at(-1);

		if (previous !== undefined && previous.distanceToSquared(point) < POINT_EPSILON_SQ) {
			continue;
		}

		kept.push(point);
	}

	if (isLoop) {
		while (kept.length > 1 && kept[0].distanceToSquared(kept[kept.length - 1]) < POINT_EPSILON_SQ) {
			kept.pop();
		}
	}

	return kept;
}

export { dropDegenerateVertices, POINT_EPSILON };
